import { dictionary } from '../../engine/dictionary';
import type { PuzzleMode } from '../../engine/types';
import { LatticeBoard } from './Board';
import {
  LATTICE_DIFFICULTIES,
  deserialize,
  generate,
  handleKey,
  isFull,
  isSolved,
  makeHint,
  moveFeedback,
  reduce,
  score,
  status,
  summarize,
  validateMove,
  type LatticeConfig,
  type LatticeMove,
  type LatticeState,
} from './logic';

export const latticeMode: PuzzleMode<LatticeState, LatticeMove, LatticeConfig> = {
  id: 'lattice',
  name: 'Lattice',
  tagline: 'Make every row and column a word',
  description:
    'Fill the little grid so every row and every column spells a word. A few letters are given; deduce the rest from the crossings.',
  accent: 'seed',
  glyph: 'lattice',
  howToPlay: [
    { title: 'Fill the grid', body: 'Tap an open cell and type a letter. Shaded letters are given and locked.' },
    { title: 'Cross-check', body: 'Every row and every column must be a real word — let the crossings guide you.' },
    { title: 'Submit', body: 'Fill every cell, then press Enter. Any valid word-square is accepted, not just ours.' },
  ],
  difficulties: LATTICE_DIFFICULTIES,
  defaultDifficultyId: 'standard',
  generate,
  reduce: (state, move) => {
    if (move.type === 'submit') {
      if (!isFull(state)) return state;
      return isSolved(state, dictionary)
        ? { ...state, solved: true }
        : { ...state, attempts: state.attempts + 1 };
    }
    return reduce(state, move);
  },
  status,
  validateMove,
  moveFeedback,
  handleKey,
  hint: (state) => makeHint(state, dictionary),
  score,
  summarize,
  serialize: (state) => state,
  deserialize,
  Board: LatticeBoard,
};
